<div class="row mt-4">
  <div class="col-md-3 mb-3">
    <div class="card text-center o-hidden h-100">
      <div class="card-body">
        <p class="countStyle">{{ totalUsers }}</p>
        <p class="tagStyle"><i class="fas fa-user-circle"></i> Users</p>
      </div>
    </div>
  </div>
  <div class="col-md-3 mb-3">
    <div class="card text-center o-hidden h-100">
      <div class="card-body">
        <p class="countStyle">{{ totalLocations }}</p>
        <p class="tagStyle"><i class="fas fa-users"></i> Locations</p>
      </div>
    </div>
  </div>
  <div class="col-md-3 mb-3">
    <div class="card text-center o-hidden h-100">
      <div class="card-body">
        <p class="countStyle">{{ totalSuggestedLocations }}</p>
        <p class="tagStyle"><i class="fas fa-users"></i> Suggested Locations</p>
      </div>
    </div>
  </div>
</div>

<!-- <div class="row mt-4">
    <div class="col-md-6">
        <canvas baseChart 
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [plugins]="barChartPlugins"
            [legend]="barChartLegend"
            [colors]="barChartColors"
            [chartType]="barChartType">
        </canvas>
    </div>
    <div class="col-md-6"></div>
</div> -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Please wait...</p>
</ngx-spinner>